export const LIST_PUBLIC_ROUTE = ['/account', '/policies'];
